import { Box, Flex, Select, SelectProps, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import i18n from "common/i18n";
import { useLanguageChooser } from "hooks/useLanguages";
import packageJson from "src/../../../package.json";
import { selectNationalFlag } from "utils/flags";

const SideMenuFooter = ({ isOpen }: { isOpen: boolean }) => {
  if (!isOpen) {
    return (
      <div className="mb-[54px] mt-5 mx-auto">
        {selectNationalFlag(i18n.language)}
      </div>
    );
  }

  return (
    <Box bg={"inherit"} mt={"sm"} mx={"sm"} mb={24}>
      <LanguageChooser />
      <Text mt={4} p={3} c={"#eee"} fz={10} fw={400} lh={1}>
        JAPP v{packageJson.version}
      </Text>
    </Box>
  );
};

const LanguageChooser = () => {
  const { handleLanguageChange, options, language, nationalFlag } =
    useLanguageChooser();

  const [dropdownOpened, { toggle }] = useDisclosure();

  const renderOption: SelectProps["renderOption"] = ({
    option: { value, label },
  }) => {
    return (
      <Flex align={"center"} gap={4}>
        {selectNationalFlag(value)}
        <Text c={"inherit"} lh={1} fz={"sm"}>
          {label}
        </Text>
      </Flex>
    );
  };
  const rightSection = dropdownOpened ? (
    <IconChevronUp color="#E9ECEF" size={20} />
  ) : (
    <IconChevronDown color="#E9ECEF" size={20} />
  );

  const defaultClassNames = {
    option: "hover:bg-gray-light hover:text-black",
    dropdown: "!bg-gray-dark !text-[#E9ECEF] !border-[#E9ECEF]",
    input: "!bg-gray-dark !text-[#E9ECEF] !border-[#E9ECEF]",
  };

  return (
    <Select
      lh={1}
      fz={"sm"}
      fw={500}
      defaultValue={language}
      scrollAreaProps={{ type: "auto" }}
      maxDropdownHeight={"calc(100vh - 200px)"}
      value={language}
      dropdownOpened={dropdownOpened}
      onDropdownOpen={toggle}
      onDropdownClose={toggle}
      onChange={handleLanguageChange}
      maw={200}
      classNames={defaultClassNames}
      withCheckIcon={false}
      data={options}
      renderOption={renderOption}
      rightSection={rightSection}
      rightSectionWidth={50}
      leftSectionWidth={50}
      leftSection={nationalFlag}
    />
  );
};

export default SideMenuFooter;
